import { db } from "@/firebase/init.js";
import {
  collection,
  query,
  orderBy,
  getDoc,
  doc,
  getDocs,
  setDoc,
  deleteDoc,
  updateDoc,
} from "firebase/firestore";
import { startAfter, limit } from "firebase/firestore";

const postsModule = {
  namespaced: true,
  state: {
    postsList: [],
    updatePost: {},
    isLoading: true,
    isFirstLoad: true,
  },
  getters: {
    getPosts: (state) => state.postsList,
    isLoading: (state) => state.isLoading,
    isFirstLoad: (state) => state.isFirstLoad,
  },
  mutations: {
    // Loading
    setLoading: (state, payload) => {
      state.isLoading = payload;
    },

    // First load
    setFirstLoad: (state, payload) => {
      state.isFirstLoad = payload;
    },

    // Get All Posts
    setPosts: (state, payload) => {
      state.postsList = payload;
    },
    // Add Post
    addPost: (state, payload) => {
      if (state.postsList.length > 0) state.postsList.unshift(payload);
      else state.postsList = [payload];
    },
    // get Review by id
    getPostById: (state, payload) => {
      state.updatePost = state.postsList.find(
        (post) => post.post_id == payload
      );
    },
    // Update Post
    updatePost: (state, payload) => {
      const findIndex = state.postsList.findIndex(
        (post) => post.post_id == payload.post_id
      );
      state.postsList[findIndex] = payload;
    },
    // Delete Post
    deletePost: (state, payload) => {
      let filtered = state.postsList.filter(function (value) {
        return value.post_id != payload;
      });
      state.postsList = filtered;
    },
  },
  actions: {
    // Get All Posts
    async fetchPosts({ commit }) {
      commit("setLoading", true);
      commit("setFirstLoad", true);
      const postsList = await getDocs(
        query(collection(db, "Posts"), orderBy("created_date", "desc"))
      );
      let postArray = [];
      if (!postsList.empty) {
        postsList.forEach((doc) => {
          postArray.push({ ...doc.data(), post_id: doc.id });
        });
      } else {
        console.log("No Posts found");
        postArray = false;
      }
      commit("setPosts", postArray);
      commit("setLoading", false);
      commit("setFirstLoad", false);
      return postsList;
    },
    // limit
    async tryPagination({ commit }) {
      commit("setFirstLoad", false);
      const first = query(
        collection(db, "Posts"),
        orderBy("created_date", "desc"),
        limit(1)
      );
      const documentSnapshots = await getDocs(first);
      documentSnapshots.forEach((doc) => console.log("first", doc.data()));

      // Get the last visible document
      const lastVisible =
        documentSnapshots.docs[documentSnapshots.docs.length - 1];

      // Construct a new query starting at this document,
      // get the next 25 Posts.
      const next = query(
        collection(db, "Posts"),
        orderBy("created_date", "desc"),
        startAfter(lastVisible),
        limit(25)
      );
      const documentSnapshotsnext = await getDocs(next);

      documentSnapshotsnext.forEach((doc) => console.log("last", doc.data()));

      console.log(next);
    },
    // Add Post
    async addPost({ commit }, payload) {
      const documentReference = doc(collection(db, "Posts"));
      const post = {
        ...payload,
        post_id: documentReference.id,
        created_date: new Date(),
      };
      setDoc(documentReference, post);
      commit("addPost", post);
    },
    // Get Post by id
    async getPostById({ commit }, payload) {
      let post = await getDoc(doc(db, "Posts", payload));
      commit("getPostById", post);
      return post.data();
    },
    // Update Post
    async updatePost({ commit }, payload) {
      updateDoc(doc(db, "Posts", payload.post_id), payload);
      commit("updatePost", payload);
    },
    // Delete Post
    async deletePost({ commit }, payload) {
      deleteDoc(doc(db, "Posts", payload));
      commit("deletePost", payload);
    },
  },
};

export default postsModule;
